var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddSmileTempIcon = function SvgAddSmileTempIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.25 9.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM12.75 9.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM15 10.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm2.5 5.125h-1.875V17.5a.625.625 0 1 1-1.25 0v-1.875H12.5a.625.625 0 1 1 0-1.25h1.875V12.5a.625.625 0 1 1 1.25 0v1.875H17.5a.625.625 0 1 1 0 1.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.25 10c0 4.825 3.925 8.75 8.75 8.75.104 0 .208-.002.312-.006a5.995 5.995 0 0 1-.885-1.516C5.697 16.935 2.75 13.805 2.75 10c0-3.998 3.252-7.25 7.25-7.25 3.805 0 6.935 2.946 7.228 6.677.55.22 1.06.52 1.516.885.004-.104.006-.208.006-.312 0-4.825-3.925-8.75-8.75-8.75S1.25 5.175 1.25 10Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.361 12.945c-1.027-.182-1.734-.753-1.751-.767a.75.75 0 1 0-.969 1.144c.046.04.98.818 2.388 1.087.05-.51.163-1 .332-1.464Z",
    clipRule: "evenodd"
  })));
};
export default SvgAddSmileTempIcon;